
<div class="tag" :style="getStyleTag">
  {{ getTagInfos.name }}
  <i v-if="deletable" class="tag-delete-btn el-icon-close" @click="removeTag"></i>
</div>
